import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-11 w-full rounded-[12px] border border-line bg-card px-3 text-sm text-ink placeholder:text-muted focus:outline-none focus:border-accent",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
